import _toConsumableArray from "/zeit/5b90bc92/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/zeit/5b90bc92/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function e(_ref) {
  var e = _ref.node,
      _ref$child = _ref.child,
      t = _ref$child === void 0 ? [] : _ref$child,
      _ref$scope = _ref.scope,
      n = _ref$scope === void 0 ? {} : _ref$scope,
      _ref$meta = _ref.meta,
      r = _ref$meta === void 0 ? {} : _ref$meta,
      _ref$family = _ref.family,
      o = _ref$family === void 0 ? {} : _ref$family;
  var a = (o.links || []).map(ne),
      s = (o.owners || []).map(ne),
      c = {
    seq: e,
    next: t.map(ne),
    meta: r,
    scope: n,
    family: {
      type: o.type || 'regular',
      links: a,
      owners: s
    }
  };

  for (var _e2 = 0; _e2 < a.length; _e2++) {
    re(a[_e2]).push(c);
  }

  for (var _e3 = 0; _e3 < s.length; _e3++) {
    oe(s[_e3]).push(c);
  }

  return c;
}

function t(e, t) {
  var n, r;
  var o = e;
  return void 0 === t ? (n = 0 === e.length ? [] : [e], r = e) : 0 === e.length ? (n = t.path, r = t.fullName) : (n = t.path.concat([e]), r = 0 === t.fullName.length ? e : t.fullName + '/' + e), new Oe(o, r, n);
}

function n() {
  var e = this.indexOf();
  -1 !== e && (this.splice(e, 1), this.indexOf = De, this.splice = Fe);
}

function r(t, n) {
  var r = e({
    scope: {
      handler: n
    },
    node: [te.run({
      fn: function fn(e, _ref2) {
        var t = _ref2.handler;
        t(e);
      }
    })]
  });
  return ie(t, r), Me({
    from: t,
    to: r
  });
}

function o(_ref3) {
  var n = _ref3.name,
      o = _ref3.parent,
      _ref3$config = _ref3.config,
      f = _ref3$config === void 0 ? {} : _ref3$config;

  var l = Ae(),
      p = n || l,
      d = t(p, o),
      m = d.fullName,
      h = e({
    node: []
  }),
      g = function g(e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }

    return g.create(e, m, t);
  };

  return g.getType = function () {
    return m;
  }, g.create = function (e) {
    return qe(g, e), e;
  }, g.sid = f.sid || null, g.graphite = h, g.shortName = p, g.domainName = o, g.compositeName = d, g.defaultConfig = f, g.kind = _, g[A] = function () {
    return g;
  }, g.id = l, g.watch = Y(r, g), g.map = Y(c, g), g.filter = Y(i, g), g.filterMap = Y(u, g), g.prepend = Y(s, g), g.subscribe = Y(a, g), g.thru = Y(Re, g), g;
}

function a(e, t) {
  return e.watch(function (e) {
    return t.next(e);
  });
}

function s(e, t) {
  var n = o({
    name: '* → ' + e.shortName,
    parent: e.domainName
  });
  return Te(n, e, {
    scope: {
      handler: t
    },
    node: [te.compute({
      fn: function fn(e, _ref4) {
        var t = _ref4.handler;
        return t(e);
      }
    })]
  }), n;
}

function c(e, t) {
  var n = o({
    name: e.shortName + ' → *',
    parent: e.domainName
  });
  return Te(e, n, {
    scope: {
      handler: t
    },
    node: [te.compute({
      fn: function fn(e, _ref5) {
        var t = _ref5.handler;
        return t(e);
      }
    })]
  }), n;
}

function i(e, t) {
  if ('function' == typeof t) return console.error('.filter(fn) is deprecated, use .filterMap instead'), u(e, t);
  var n = o({
    name: e.shortName + ' →? *',
    parent: e.domainName
  });
  return Te(e, n, {
    scope: {
      fn: t.fn
    },
    node: [te.filter({
      fn: function (e) {
        function t(t, n) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e, _ref6) {
        var t = _ref6.fn;
        return t(e);
      })
    })]
  }), n;
}

function u(e, t) {
  var n = o({
    name: e.shortName + ' →? *',
    parent: e.domainName
  });
  return Te(e, n, {
    scope: {
      fn: t
    },
    node: [te.compute({
      fn: function (e) {
        function t(t, n) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e, _ref7) {
        var t = _ref7.fn;
        return t(e);
      })
    }), te.check.defined()]
  }), n;
}

function f(e) {
  return e.compositeName ? e.compositeName.fullName : e.domainName ? e.domainName.fullName : e.id;
}

function l(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "combine";
  var n = t + '(',
      r = '',
      o = 0;

  for (var _t in e) {
    var _a = e[_t];
    if (null != _a && (n += r, n += J(_a) ? f(_a) : _a.toString()), 25 === (o += 1)) break;
    r = ', ';
  }

  return n + ')';
}

function p(e) {
  var t = o({
    name: l(e, 'merge')
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _n = _step.value;
      Me({
        from: _n,
        to: t
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return t;
}

function d(e, t) {
  var n = {};
  var r = Q(e) ? e.updates : e;

  for (var _e4 in t) {
    n[_e4] = r.filter({
      fn: t[_e4]
    }), r = r.filter({
      fn: Y(Pe, t[_e4])
    });
  }

  return n.__ = r, n;
}

function m(e, t) {
  var n = 'object' == typeof e ? Object.assign({}, _e(t), e) : _e(t);
  return {
    config: n,
    name: 'object' == typeof e || void 0 === e ? n.name : e
  };
}

function h(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return o(m(e, t));
}

function g(e) {
  if (e !== Object(e)) throw Error('expect observable to be an object');
  var t = A in e ? e[A]() : e;
  if (!t.subscribe) throw Error('expect observable to have .subscribe');
  var n = h(),
      r = ce.bind(null, n, {});
  return t.subscribe({
    next: n,
    error: r,
    complete: r
  }), n;
}

function b(e) {
  for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    t[_key2 - 1] = arguments[_key2];
  }

  for (var _i = 0, _t2 = t; _i < _t2.length; _i++) {
    var _n2 = _t2[_i];
    e.on(_n2, function () {
      return e.defaultState;
    });
  }

  return e;
}

function y(e, t) {
  var n = e.subscribers.get(t);
  return void 0 !== n && (n(), e.subscribers.delete(t)), e;
}

function N(e, t, n) {
  return e.off(t), e.subscribers.set(t, Be(t, e, {
    scope: {
      handler: n,
      state: e.stateRef
    },
    node: [te.compute({
      fn: function fn(e, _ref8) {
        var t = _ref8.handler,
            n = _ref8.state;
        var r = t(le(n), e);
        if (void 0 !== r) return pe(n, r);
      }
    })]
  })), e;
}

function k(e) {
  var t = {
    subscribe: function subscribe(t) {
      if (t !== Object(t)) throw Error('expect observer to be an object');
      return S(e, function (e) {
        t.next && t.next(e);
      });
    }
  };
  return t[A] = function () {
    return this;
  }, t;
}

function v(e, t, n) {
  if (!n || !J(t)) {
    if ('function' != typeof t) throw Error('watch requires function handler');
    return S(e, t);
  }

  if ('function' != typeof n) throw Error('second argument should be a function');
  return t.watch(function (t) {
    return n(e.getState(), t);
  });
}

function S(e, t) {
  if ('function' != typeof t) throw Error('expect listener to be a function');
  return t(e.getState()), r(e, t);
}

function w(e, t, n) {
  var r;
  var o = e.getState();
  void 0 !== o && (r = t(o, n));
  var a = x({
    config: {
      name: e.shortName + ' → *'
    },
    currentState: r,
    parent: e.domainName
  });
  return Te(e, a, {
    scope: {
      handler: t,
      state: a.stateRef
    },
    node: [te.compute({
      fn: function fn(e, _ref9) {
        var t = _ref9.state,
            n = _ref9.handler;
        return n(e, le(t));
      }
    }), te.check.defined(), te.check.changed({
      store: a.stateRef
    })]
  }), a;
}

function x(n) {
  var r = n.currentState,
      o = n.config,
      a = n.parent,
      s = o.name,
      _o$sid = o.sid,
      c = _o$sid === void 0 ? null : _o$sid,
      i = fe(r),
      u = fe(r),
      f = s || i.id,
      l = t(f, a),
      p = h('update ' + f),
      d = {
    subscribers: new Map(),
    compositeName: l,
    graphite: e({
      node: [te.check.defined(), te.update({
        store: i
      }), te.check.changed({
        store: u
      }), te.update({
        store: u
      })]
    }),
    kind: P,
    id: i.id,
    shortName: f,
    domainName: a,
    updates: p,
    defaultConfig: o,
    defaultState: r,
    getState: Y(le, i),
    stateRef: i,
    sid: c
  };
  return d.subscribe = Y(S, d), d.watch = Y(v, d), d.reset = Y(b, d), d.on = Y(N, d), d.off = Y(y, d), d.map = Y(w, d), d.thru = Y(Re, d), d.setState = Y(Ee, d), d[A] = Y(k, d), Me({
    from: d,
    to: p
  }), ie(d, p), d;
}

function j(e, t) {
  if (void 0 === e) throw Error("current state can't be undefined, use null instead");
  return x({
    currentState: e,
    config: _e(t)
  });
}

function C(e, n) {
  var r = t(n, e.domainName);
  e.shortName = n, e.compositeName ? (e.compositeName.path = r.path, e.compositeName.shortName = r.shortName, e.compositeName.fullName = r.fullName) : e.compositeName = r;
}

function q(e, t) {
  var n = Array.isArray(e) ? Ke(e, function (e) {
    return e.slice();
  }, []) : Ke(e, function (e) {
    return Object.assign({}, e);
  }, {});
  return t ? n.map(t) : n;
}

function E(e, t) {
  var n = {};

  for (var _r in t) {
    var _o = t[_r],
        _a2 = n[_r] = h(_r);

    e.on(_a2, _o);
  }

  return n;
}

function I(e) {
  var t = {};

  for (var _n3 in e) {
    var _r2 = e[_n3];
    t[_n3] = Q(_r2) ? _r2 : x({
      currentState: _r2,
      config: {
        name: _n3
      }
    });
  }

  return t;
}

function O(e, t) {
  var n = x({
    currentState: t,
    parent: e.domainName,
    config: {
      name: e.shortName
    }
  });
  return n.on(e.done, function (e, _ref10) {
    var t = _ref10.result;
    return t;
  }), n;
}

function R(e, t) {
  var n = x({
    currentState: t,
    parent: e.domainName,
    config: {
      name: e.shortName
    }
  });
  return n.on(e, function (e, t) {
    return t;
  }), n;
}

function D(e, t) {
  return Q(e) ? e : U(e) ? R(e, t) : V(e) ? O(e, t) : I(e);
}

function F() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  if (0 === e.length) throw Error('at least one argument required');
  var t, n, r, o;
  {
    var _r3 = e[e.length - 1];
    'function' == typeof _r3 ? (n = e.slice(0, -1), t = _r3) : n = e;
  }

  if (1 === n.length) {
    var _e5 = n[0];
    Q(_e5) || (r = _e5, o = 1);
  }

  return o || (r = n, t && (t = ze(t))), q(r, t);
}

function H(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var o;
  void 0 === t && 'source' in e && (t = e.clock || e.sampler, n = e.fn, r = e.greedy, o = e.target, e = e.source), void 0 === t && (t = e);
  var a = Ue(e),
      s = Ue(t);
  return 'boolean' == typeof n && (r = n, n = void 0), (Q(a) ? Q(s) ? Le : Je : Qe)(a, s, n, r, o);
}

function B(_ref11) {
  var e = _ref11.name,
      t = _ref11.parent,
      n = _ref11.config;
  var r = n.handler,
      a = o({
    name: e,
    parent: t,
    config: n
  }),
      s = a.create,
      c = o({
    name: a.shortName + ' done',
    parent: t,
    config: n
  }),
      i = o({
    name: a.shortName + ' fail',
    parent: t,
    config: n
  }),
      u = o({
    name: a.shortName + ' finally',
    parent: t,
    config: n
  });
  c.graphite.seq.push(Ye), i.graphite.seq.push(Ye);

  var f = r || function () {
    return console.error("no handler used in " + a.getType()), Promise.resolve();
  };

  a.done = c, a.fail = i, a.finally = u, a.use = function (e) {
    return f = e, a;
  };

  var l = function l() {
    return f;
  };

  a.use.getCurrent = l, a.kind = K, a.graphite.scope = {
    done: c,
    fail: i,
    anyway: u,
    getHandler: l
  }, a.graphite.seq.push(te.compute({
    fn: function fn(e) {
      return 'object' == typeof e && null !== e && 'ɔ' in e ? e.ɔ : {
        params: e,
        req: {
          rs: function rs(e) {},
          rj: function rj(e) {}
        }
      };
    }
  }), te.run({
    fn: function fn(_ref12, _ref13) {
      var e = _ref12.params,
          t = _ref12.req;
      var n = _ref13.getHandler,
          r = _ref13.done,
          o = _ref13.fail,
          a = _ref13.anyway;
      return function (e, t, n, r) {
        var o,
            a,
            s = 0;

        try {
          a = e(t);
        } catch (e) {
          s = 1, o = e;
        }

        s ? r(o) : 'object' != typeof a || null === a || 'function' != typeof a.then ? n(a) : a.then(n, r);
      }(n(), e, Y(We, {
        event: r,
        anyway: a,
        params: e,
        handler: t.rs
      }), Y(Xe, {
        event: o,
        anyway: a,
        params: e,
        handler: t.rj
      })), e;
    }
  })), a.create = function (e, t, n) {
    var r = new Ve();
    return s({
      "ɔ": {
        params: e,
        req: r
      }
    }, a.getType(), n), r.req;
  };
  var p = j(Boolean(0)).on(a, function () {
    return Boolean(1);
  }).reset(c).reset(i);
  return a.pending = p, ie(a, c), ie(a, i), ie(a, u), ie(a, p), a;
}

function T(e, t) {
  return B(m(e, t));
}

function M(n) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function n(_ref14) {
    var r = _ref14.name,
        _ref14$config = _ref14.config,
        a = _ref14$config === void 0 ? {} : _ref14$config,
        s = _ref14.parent,
        c = _ref14.parentHooks;
    var i = Ze(),
        u = t(r || '', s),
        f = new Set(),
        l = new Set(),
        p = new Set(),
        d = new Set(),
        m = o({
      name: u.fullName + " event hook",
      parent: u
    }),
        h = o({
      name: u.fullName + " effect hook",
      parent: u
    }),
        g = o({
      name: u.fullName + " store hook",
      parent: u
    }),
        b = o({
      parent: u
    });
    c && (Me({
      from: m,
      to: c.event
    }), Me({
      from: h,
      to: c.effect
    }), Me({
      from: g,
      to: c.store
    }), Me({
      from: b,
      to: c.domain
    }));
    var y = {
      event: m,
      effect: h,
      store: g,
      domain: b
    },
        N = e({
      node: [],
      scope: {
        history: {
          domains: f,
          storages: l,
          effects: p,
          events: d
        }
      }
    });
    return {
      graphite: N,
      compositeName: u,
      id: i,
      defaultConfig: a,
      getType: function getType() {
        return u.fullName;
      },
      onCreateEvent: $e(m, d, N),
      onCreateEffect: $e(h, p, N),
      onCreateStore: $e(g, l, N),
      onCreateDomain: $e(b, f, N),
      event: function event(e, t) {
        var n = o({
          name: e,
          parent: u,
          config: _e(t)
        });
        return ie(N, n), m(n), n;
      },
      effect: function effect(e, t) {
        var n = B({
          name: e,
          parent: u,
          config: _e(t)
        });
        return ie(N, n), h(n), n;
      },
      domain: function domain(e, t) {
        var r = n({
          name: e,
          parent: u,
          parentHooks: y,
          config: _e(t)
        });
        return ie(N, r), b(r), r;
      },
      store: function store(e, t) {
        var n = x({
          currentState: e,
          parent: u,
          config: _e(t)
        });
        return ie(N, n), g(n), n;
      },
      kind: z,
      sid: a.sid || null
    };
  }(m(n, r));
}

import A from 'symbol-observable';
var P = 'store',
    _ = 'event',
    K = 'effect',
    z = 'domain';
var G = {
  store: P,
  event: _,
  effect: K,
  domain: z
};

var J = function J(e) {
  return ('function' == typeof e || 'object' == typeof e && null !== e) && 'kind' in e;
},
    L = function L(e) {
  return function (t) {
    return J(t) && t.kind === e;
  };
},
    Q = L(P),
    U = L(_),
    V = L(K),
    W = L(z);

var X = {
  unit: J,
  store: Q,
  event: U,
  effect: V,
  domain: W
};

var Y = function Y(e, t) {
  return e.bind(null, t);
},
    Z = function Z() {
  var e = 0;
  return function () {
    return (++e).toString(36);
  };
},
    $ = Z(),
    ee = function ee(e, t) {
  return {
    id: $(),
    type: e,
    data: t
  };
},
    te = {
  barrier: function barrier(_ref15) {
    var e = _ref15.barrierID,
        _ref15$priority = _ref15.priority,
        t = _ref15$priority === void 0 ? "barrier" : _ref15$priority;
    return ee('barrier', {
      barrierID: e,
      priority: t
    });
  },
  check: {
    defined: function defined() {
      return ee('check', {
        type: 'defined'
      });
    },
    changed: function changed(_ref16) {
      var e = _ref16.store;
      return ee('check', {
        type: 'changed',
        store: e
      });
    }
  },
  compute: ee.bind(null, 'compute'),
  filter: ee.bind(null, 'filter'),
  run: ee.bind(null, 'run'),
  tap: ee.bind(null, 'tap'),
  update: ee.bind(null, 'update')
},
    ne = function ne(e) {
  return e.graphite || e;
},
    re = function re(e) {
  return e.family.owners;
},
    oe = function oe(e) {
  return e.family.links;
},
    ae = function ae(e, t) {
  var n = e.indexOf(t);
  -1 !== n && e.splice(n, 1);
},
    se = function se(e, t) {
  var n;
  e.next.length = 0, e.seq.length = 0, e.scope = null;
  var r = oe(e);

  for (; n = r.pop();) {
    ae(re(n), e), (t || 'crosslink' === n.family.type) && se(n, t);
  }

  for (r = re(e); n = r.pop();) {
    ae(n.next, e), ae(oe(n), e), 'crosslink' === n.family.type && se(n, t);
  }
},
    ce = function ce(e) {
  var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref17.deep;

  if (Q(e)) e.subscribers.clear();else if (W(e)) {
    var _ne = ne(e),
        _t3 = _ne.scope,
        _n4 = _t3.history;

    _n4 && (_n4.events.clear(), _n4.effects.clear(), _n4.storages.clear(), _n4.domains.clear()), _t3.history = null;
  }
  se(ne(e), !!t);
},
    ie = function ie(e, t) {
  var n = ne(e),
      r = ne(t);
  r.family.type = 'crosslink', re(r).push(n), oe(n).push(r);
},
    ue = Z(),
    fe = function fe(e) {
  return {
    id: ue(),
    current: e
  };
},
    le = function le(_ref18) {
  var e = _ref18.current;
  return e;
},
    pe = function pe(e, t) {
  return e.current = t;
},
    de = Z(),
    me = function me(e) {
  switch (e) {
    case 'child':
      return 0;

    case 'pure':
      return 1;

    case 'barrier':
      return 2;

    case 'sampler':
      return 3;

    case 'effect':
      return 4;

    default:
      return -1;
  }
};

var he = function he(e, t, n, r) {
  _classCallCheck(this, he);

  this.value = e, this.rank = t, this.left = n, this.right = r;
};

var ge = function ge(e) {
  return e ? be(e.left, e.right) : null;
},
    be = function be(e, t) {
  if (null === e) return t;
  if (null === t) return e;
  var n;
  (function (e, t) {
    return e.type === t.type ? e.id > t.id : me(e.type) > me(t.type);
  })(e.value, t.value) && (n = e, e = t, t = n);
  var r = be(e.right, t),
      o = e.left,
      a = e.rank;
  return null === o ? (o = r, r = null) : (o.rank < r.rank && (n = o, o = r, r = n), a = r.rank + 1), new he(e.value, a, o, r);
};

var ye = function ye(e, t) {
  _classCallCheck(this, ye);

  this.value = {
    current: e
  }, this.parent = t;
};

var Ne = function Ne(e) {
  _classCallCheck(this, Ne);

  this.isChanged = 1, this.isFailed = 0, this.scope = e;
};

var ke = 0,
    ve = null;

var Se = new Set(),
    we = function we(e) {
  ve = function (e, t) {
    return be(new he(e, 1, null, null), t);
  }(e, ve);
};

var xe = 0;

var je = function je(e, t) {
  we({
    step: ne(e),
    firstIndex: 0,
    stack: new ye(t, null),
    resetStop: 0,
    type: 'pure',
    id: ++ke
  });
},
    Ce = function Ce() {
  var e = xe;
  xe = 1;
  var t = {
    stop: 0
  };
  var n;

  e: for (; ve;) {
    n = ve.value, ve = ge(ve);

    var _n5 = n,
        _e6 = _n5.step,
        _r4 = _n5.firstIndex,
        _o2 = _n5.stack,
        _a3 = _n5.resetStop,
        _s = _n5.type,
        _c = new Ne(_e6.scope);

    for (var _n6 = _r4; _n6 < _e6.seq.length && !t.stop; _n6++) {
      var _a4 = _e6.seq[_n6];

      switch (_a4.type) {
        case 'barrier':
          {
            var _t4 = _a4.data.barrierID,
                _i2 = _a4.data.priority;

            if (_n6 !== _r4 || _s !== _i2) {
              Se.has(_t4) || (Se.add(_t4), we({
                step: _e6,
                firstIndex: _n6,
                stack: _o2,
                resetStop: 0,
                type: _i2,
                id: ++ke
              }));
              continue e;
            }

            Se.delete(_t4), _c.isFailed = 0, _c.isChanged = 1;
            break;
          }

        case 'check':
          switch (_a4.data.type) {
            case 'defined':
              _c.isChanged = void 0 !== le(_o2.value);
              break;

            case 'changed':
              _c.isChanged = le(_a4.data.store) !== le(_o2.value);
          }

          break;

        case 'filter':
          _c.isChanged = !!Ie(_c, _a4.data, _o2.value);
          break;

        case 'run':
          if (_n6 !== _r4 || 'effect' !== _s) {
            we({
              step: _e6,
              firstIndex: _n6,
              stack: _o2,
              resetStop: 0,
              type: 'effect',
              id: ++ke
            });
            continue e;
          }

        case 'compute':
          pe(_o2.value, Ie(_c, _a4.data, _o2.value));
          break;

        case 'update':
          pe(_a4.data.store, le(_o2.value));
          break;

        case 'tap':
          Ie(_c, _a4.data, _o2.value);
      }

      t.stop = _c.isFailed || !_c.isChanged;
    }

    if (!t.stop) for (var _t5 = 0; _t5 < _e6.next.length; _t5++) {
      we({
        step: _e6.next[_t5],
        firstIndex: 0,
        stack: new ye(le(_o2.value), _o2),
        resetStop: 1,
        type: 'child',
        id: ++ke
      });
    }
    _a3 && (t.stop = 0);
  }

  xe = e;
},
    qe = function qe(e, t) {
  je(e, t), Ce();
},
    Ee = function Ee(e, t) {
  je(e, t), xe || Ce();
},
    Ie = function Ie(e, _ref19, n) {
  var t = _ref19.fn;
  var r = null,
      o = 0;

  try {
    r = t(le(n), e.scope);
  } catch (e) {
    console.error(e), o = 1;
  }

  return e.isFailed = o, r;
};

var Oe = function Oe(e, t, n) {
  _classCallCheck(this, Oe);

  this.shortName = e, this.fullName = t, this.path = n;
};

var Re = function Re(e, t) {
  return t(e);
},
    De = function De() {
  return -1;
},
    Fe = function Fe() {
  return [];
},
    He = function He(e) {
  var t = e.parent.next,
      r = {
    indexOf: t.indexOf.bind(t, e.child),
    splice: t.splice.bind(t)
  },
      o = n.bind(r);
  return o.unsubscribe = n.bind(r), o;
},
    Be = function Be(e, t, n) {
  return He({
    parent: ne(e),
    child: Te(e, t, n)
  });
},
    Te = function Te(t, n, _ref20) {
  var r = _ref20.node,
      o = _ref20.scope,
      a = _ref20.meta;
  var s = ne(t),
      c = e({
    node: r,
    child: [n],
    scope: o,
    meta: a,
    family: {
      type: 'crosslink',
      owners: [s, n],
      links: [n]
    }
  });
  return s.next.push(c), c;
},
    Me = function Me(e) {
  var t = ne(e.from),
      n = ne(e.to);
  return t.next.push(n), He({
    child: n,
    parent: t
  });
},
    Ae = Z(),
    Pe = function Pe(e, t) {
  return !e(t);
},
    _e = function _e() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.assign({}, e, e.ɔ || {});
},
    Ke = function Ke(e, t, n) {
  var r = [te.check.defined(), te.filter({
    fn: function fn(e, _ref21) {
      var t = _ref21.target,
          n = _ref21.key;
      return e !== le(t)[n];
    }
  }), te.tap({
    fn: function fn(e, _ref22) {
      var t = _ref22.isFresh,
          n = _ref22.target,
          r = _ref22.clone;
      le(t) || (pe(n, r(le(n))), pe(t, 1));
    }
  }), te.tap({
    fn: function fn(e, _ref23) {
      var t = _ref23.target,
          n = _ref23.key;
      le(t)[n] = e;
    }
  }), te.barrier({
    barrierID: de()
  }), te.compute({
    fn: function fn(e, _ref24) {
      var t = _ref24.isFresh,
          n = _ref24.target;
      return pe(t, 0), le(n);
    }
  })],
      o = t(n),
      a = x({
    currentState: o,
    config: {
      name: l(e)
    }
  }),
      s = fe(0);

  for (var _c2 in e) {
    var _i3 = e[_c2];
    Q(_i3) ? (n[_c2] = _i3.defaultState, o[_c2] = _i3.getState(), Te(_i3, a, {
      scope: {
        key: _c2,
        clone: t,
        target: a.stateRef,
        isFresh: s
      },
      node: r
    })) : o[_c2] = n[_c2] = _i3;
  }

  return a.defaultShape = e, a.defaultState = n, a;
},
    ze = function ze(e) {
  return function (t) {
    return e.apply(void 0, _toConsumableArray(t));
  };
},
    Ge = function Ge(e, t, n, r, o) {
  return ie(e, Te(t, o, {
    scope: {
      state: e.stateRef,
      fn: n
    },
    node: [!r && te.barrier({
      barrierID: de(),
      priority: 'sampler'
    }), te.compute({
      fn: n ? function (e, _ref25) {
        var t = _ref25.state,
            n = _ref25.fn;
        return n(le(t), e);
      } : function (e, _ref26) {
        var t = _ref26.state;
        return le(t);
      }
    })].filter(Boolean)
  })), o;
},
    Je = function Je(e, t, n, r, a) {
  return Ge(e, t, n, r, a || o({
    name: e.shortName,
    parent: e.domainName
  }));
},
    Le = function Le(e, t, n, r, o) {
  var a = le(e.stateRef);
  return Ge(e, t, n, r, o || x({
    currentState: n ? n(a, le(t.stateRef)) : a,
    config: {
      name: e.shortName
    },
    parent: e.domainName
  }));
},
    Qe = function Qe(e, t, n, r, a) {
  a = a || o({
    name: e.shortName,
    parent: e.domainName
  });
  var s = fe(0),
      c = fe(),
      i = fe();
  return ie(t, Te(e, a, {
    scope: {
      hasSource: s
    },
    node: [te.update({
      store: c
    }), te.compute({
      fn: function fn(e, _ref27) {
        var t = _ref27.hasSource;
        pe(t, 1);
      }
    }), te.filter({
      fn: function fn() {
        return 0;
      }
    })]
  })), ie(e, Te(t, a, {
    scope: {
      sourceState: c,
      clockState: i,
      hasSource: s,
      fn: n
    },
    node: [te.update({
      store: i
    }), te.filter({
      fn: function fn(e, _ref28) {
        var t = _ref28.hasSource;
        return le(t);
      }
    }), !r && te.barrier({
      barrierID: de(),
      priority: 'sampler'
    }), te.compute({
      fn: n ? function (e, _ref29) {
        var t = _ref29.sourceState,
            n = _ref29.clockState,
            r = _ref29.fn;
        return r(le(t), le(n));
      } : function (e, _ref30) {
        var t = _ref30.sourceState;
        return le(t);
      }
    })].filter(Boolean)
  })), a;
},
    Ue = function Ue(e) {
  return J(e) ? e : q(e);
};

var Ve = function Ve() {
  var _this = this;

  _classCallCheck(this, Ve);

  var e = new Promise(function (e, t) {
    _this.rs = e, _this.rj = t;
  });
  this.req = e, e.catch(function () {});
};

var We = function We(_ref31, o) {
  var e = _ref31.event,
      t = _ref31.anyway,
      n = _ref31.params,
      r = _ref31.handler;
  Ee(t, {
    status: 'done',
    params: n,
    result: o
  }), Ee(e, {
    handler: r,
    toHandler: o,
    result: {
      params: n,
      result: o
    }
  });
},
    Xe = function Xe(_ref32, o) {
  var e = _ref32.event,
      t = _ref32.anyway,
      n = _ref32.params,
      r = _ref32.handler;
  Ee(t, {
    status: 'fail',
    params: n,
    error: o
  }), Ee(e, {
    handler: r,
    toHandler: o,
    result: {
      params: n,
      error: o
    }
  });
},
    Ye = te.run({
  fn: function fn(_ref33) {
    var e = _ref33.handler,
        t = _ref33.toHandler,
        n = _ref33.result;
    return e(t), n;
  }
}),
    Ze = Z(),
    $e = function $e(e, t, n) {
  return e.watch(function (e) {
    t.add(e);
  }), ie(n, e), function (n) {
    return t.forEach(n), e.watch(n);
  };
},
    et = "20.2.0";

var tt = {
  filterChanged: te.filter({
    fn: function fn(e, _ref34) {
      var t = _ref34.state;
      return void 0 !== e && e !== le(t);
    }
  }),
  noop: te.compute({
    fn: function fn(e) {
      return e;
    }
  })
};
export { G as Kind, tt as blocks, ce as clearNode, F as combine, E as createApi, M as createDomain, T as createEffect, h as createEvent, e as createNode, j as createStore, F as createStoreObject, Me as forward, g as fromObservable, X as is, qe as launch, p as merge, D as restore, O as restoreEffect, R as restoreEvent, I as restoreObject, H as sample, C as setStoreName, d as split, te as step, et as version };